<script>
import { VRow, VSpacer, VSnackbar } from 'vuetify/lib';
import dataMixin from '../../mixins/data-mixin';
import axios from 'axios';
import BButton from '@/components/global_components/BButton';
import BToggleButton from '@/components/global_components/BToggleButton';
import { VForm } from 'vuetify/lib';

const loadDataFunctionality = {
  props: {
    formIdentifier: { type: Object, required: true },
    closable: { type: Boolean, default: true },
    load: {
      type: Function,
      default: ({ uuid, type }) => axios.get(`/v1/${type}/${uuid}`),
    },
    newData: {
      type: Function,
      default: () => {
        return { uuid: undefined, data: {} };
      },
    },
    alwaysLoadDataByCreated: Boolean,
    getFromTraegerschaftAfterCreation: Boolean,
  },
  mixins: [
    dataMixin('formData', '', {}),
    dataMixin('persistentData', 'persistentData'),
    dataMixin('formIsDirty', 'transientData.formIsDirty'),
    dataMixin(
      'apiGetRequestPending',
      'transientData.apiGetRequestPending',
      false
    ),
    dataMixin('saveCallPending', 'transientData.saveCallPending', false),
  ],
  created() {
    if (this.persistentData === undefined) {
      if (this.formIdentifier.uuid === undefined) {
        this.persistentData = this.newData();
      } else {
        this.loadDataFromApi();
      }
    }
  },
  methods: {
    loadDataFromApi() {
      this.apiGetRequestPending = true;
      return this.load(this.formIdentifier)
        .then(this.resolveApiResponse)
        .then(() => {
          this.formIsDirty = false;
          this.apiGetRequestPending = false;
        });
    },
    resolveApiResponse(response) {
      var responseWithUUIDs = response.data;
      this.persistentData = responseWithUUIDs;

      // this.clearIsSavedState();

      this.$emit('afterApiLoad');
    },
  },
  provide() {
    return { _formIdentifier: this.formIdentifier };
  },
};

const saveDataFunctionality = {
  props: {
    save: Function,
    saveable: { type: Boolean, default: true },
  },
  data() {
    return {
      saveSuccess: false,
      //saveFailed: false,
      showSnackbar: false,
    };
  },
  computed: {
    /*showSnackbar: {
      get() {
        return this.saveSuccess || this.saveFailed;
      },
      set(value) {
        if (!value) {
          this.saveSuccess = false;
          this.saveFailed = false;
        }
      },
    },*/
  },
  methods: {
    saveAction() {
      if (this.$refs.form.validate()) {
        this.saveCallPending = true;
        this.saveCallback();
      } else {
        // Wie einen Fehlerhandhaben ggf. Disablen bis Form Frontendseitig valide
      }
    },
    saveCallback() {
      this.saveForm()
        .then(
          (response) => {
            if (response && 200 <= response.statusCode < 300) {
              if (
                response?.data !== undefined &&
                this.formIdentifier.uuid == undefined //wenn ein neues Objekt erstellt wurde nach dem Speichern ansicht wachseln
              ) {
                if (this.getFromTraegerschaftAfterCreation) {
                  this.formIdentifier.uuid = response.data.traegerschaft;
                } else {
                  this.formIdentifier.uuid = response.data.id;
                }
                this.loadDataFromApi();

                const currentRoute = this.$router.currentRoute;
                let uuid = this.formIdentifier.uuid;
                const nextRoute = {
                  name: currentRoute.name,
                  params: { uuid },
                };
                this.$router.push(nextRoute);
              } else {
                //this.readOnly = true;
                this.loadDataFromApi();
              }
              this.saveSuccess = true;
              this.showSnackbar = true;
              this.$emit('saveSuccessful');
            } else {
              this.$emit('afterApiLoadWithError');
            }
          },
          (err) => {
            this.$emit('afterApiLoadWithError', err);

            //this.saveFailed = true;

            this.saveSuccess = false;
            this.handleErrors(err);
          }
        )
        .then(() => {
          this.saveCallPending = false;
        });
    },
    saveForm() {
      return this.formIdentifier.uuid === undefined
        ? axios.post(
            `/v1/${this.formIdentifier.type}`,
            this.formData.persistentData
          )
        : axios
            .put(
              `/v1/${this.formIdentifier.type}/${this.formIdentifier.uuid}`, //TODO auf athentification warten
              this.formData.persistentData
            )
            .then(this.setFormClean);
    },
  },
  watch: {
    saveSuccess: function (val) {
      if (val == false || val == true) {
        this.showSnackbar = true;
      }
    },
  },
};

const readModeFunctionality = {
  mixins: [dataMixin('readOnly', 'transientData.readOnly')],
  props: {
    editable: { type: Boolean, default: true },
  },
  created() {
    this.readOnly = this.formIdentifier.uuid !== undefined;
  },
};

const formPropertiesFunctionality = {
  props: {
    formProperties: { type: Object, default: () => {} },
  },
  data() {
    return {
      form: {
        uuid: this.formIdentifier.uuid,
      },
    };
  },
  provide() {
    return { $form: this.form };
  },
  watch: {
    formProperties: {
      handler(newProperties) {
        Object.entries(newProperties || {}).forEach(([key, value]) =>
          this.$set(this.form, key, value)
        );
      },
      immediate: true,
      deep: true,
    },
  },
};

export default {
  name: 'FormModule',
  props: {
    tabs: Array,
    noHeader: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    loadDataFunctionality,
    saveDataFunctionality,
    readModeFunctionality,
    formPropertiesFunctionality,
  ],

  render(createElement) {
    const self = this;
    const editButton = createElement(
      BToggleButton,
      {
        props: { size: '28px', toggle: this.readOnly },
        on: { click: () => (this.readOnly = !this.readOnly) },
      },
      'Bearbeiten'
    );
    const saveButton = createElement(
      BButton,
      {
        props: {
          size: '28px',
          // disabled: !this.formIsDirty
        },
        on: { click: this.save || this.saveAction },
      },
      'Speichern'
    );
    const closeButton = createElement(
      BButton,
      {
        props: { size: '28px' },
        on: { click: (event) => this.$emit('close', event) },
      },
      'Schließen'
    );
    const actionsRow = createElement(
      'b-row',
      {
        props: { noFlex: true, center: true },
      },
      [
        ...(self.editable ? self.$slots['edit-button'] || [editButton] : []),
        ...(self.saveable ? self.$slots['save-button'] || [saveButton] : []),
        ...(self.closable ? self.$slots['close-button'] || [closeButton] : []),
        // closeButton,
      ]
    );

    const header = createElement(
      VRow,
      { class: 'b-form-module__form-header', props: { align: 'center' } },
      [...(self.$slots['header'] || []), createElement(VSpacer), actionsRow]
    );

    return createElement('div', [
      this.noHeader ? '' : header,
      createElement(VForm, { ref: 'form' }, [
        createElement(
          'div',
          { class: 'b-form-module__content' },
          [...self.$slots['content']] || []
        ),
      ]),
      createElement(
        VSnackbar,
        {
          props: {
            value: this.showSnackbar,
            timeout: 4000,
            color: this.saveSuccess ? `primary` : `red`,
          },
          on: {
            input: (event) => (this.showSnackbar = event),
          },
        },
        this.saveSuccess ? 'Speichern erfolgreich' : 'Speichern fehlgeschlagen'
      ),
    ]);
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/form-module';
</style>
